// extracted by mini-css-extract-plugin
export var acitonButtons = "_gr-0";
export var additionalIcon = "_gr-f";
export var block = "_gr-1";
export var blockContent = "_gr-7";
export var blockDescription = "_gr-8";
export var blockIcon = "_gr-9";
export var blockTitle = "_gr-6";
export var border = "_gr-a";
export var center = "_gr-l";
export var edge = "_gr-b";
export var edgeLabel = "_gr-c";
export var edgePath = "_gr-d";
export var error = "_gr-e";
export var flowchart = "_gr-g";
export var flowchartContent = "_gr-h";
export var highlighted = "_gr-3";
export var hover = "_gr-4";
export var icon = "_gr-i";
export var left = "_gr-m";
export var navButton = "_gr-j";
export var navButtons = "_gr-k";
export var right = "_gr-n";
export var selected = "_gr-2";
export var small = "_gr-5";